import appConfig from "shared/services/appConfig";
import { type AppConfig } from "shared/services/appConfig/types";
import { useGlobalStore } from "shared/stores/global";

export default () => {
  const config: AppConfig = appConfig.getConfig(import.meta.env.VITE_REGION);

  useGlobalStore().setAppConfig(config);
};
